// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"540":"1337e8a1","973":"1337e8a1"}[chunkId] + ".chunk.css";
};